export default __webpack_public_path__ + "static/media/profile.4040721b.png";